import PropTypes from 'prop-types'
import React from 'react'
import { Well } from 'react-bootstrap'
import logo from '../images/loader.gif'

class Loading extends React.Component {
  render() {
    let message = 'Loading...'
    if (this.props.message) {
      message = this.props.message
    }
    return (
      <div style={{ paddingTop: '10%', paddingRight: '20%', paddingBottom: '10%', paddingLeft: '20%', opacity: '0.7' }}>
        <Well>
          <img className="center-block" style={{ height: 50, width: 50 }} alt="" src={logo} />
          <div className="text-center">
            <span>{message}</span>
          </div>
        </Well>
      </div>
    )
  }
}

Loading.propTypes = {
  /** Optional message rendered. By default: 'Loading...' */
  message: PropTypes.string,
}
export default Loading
